import React from 'react'
import { LivestockTypeName } from 'api/models'
import Tippy from '@tippyjs/react'
import { TooltipIcon } from './TooltipIcon'

const LIVESTOCK_CLASS_HELP = {
  SHEEP: {
    ['hoggets ewe']: 'Replacement ewe hoggets intended for breeding',
    ['hoggets ram']: 'Ram hoggets for breeding',
    ['hoggets other']: 'All trading hoggets irrespective of sex',
  },
  BEEF: {
    ['ma cows']: 'Over 2 years old',
    ['heifers r2']: '1-year-old to 2-years-old',
    ['heifers r1']: 'Weaner to 1-year-old',
    ['bull beef r1']: 'Weaner to 1-year-old',
    ['bull beef r2']: '1-year-old to 2-years-old',
    ['bull beef r3']: 'Over 2 years old',
    ['steers r1']: 'Weaner to 1-year-old',
    ['steers r2']: '1-year-old to 2-years-old',
    ['steers r3']: 'Over 2 years old',
  },
  DAIRY: {
    ['ma cows']: 'Over 2 years old',
    ['heifers r2']: '1-year-old to 2-years-old',
    ['heifers r1']: 'Calf to 1-year-old',
  },
  DEER: {
    ['hinds r2']: '1-year-old to 2-years-old',
    ['hinds r1']: 'Weaner to 1-year-old',
    ['stags r1']: 'Weaner to 1-year-old',
    ['stags r2']: '1-year-old to 2-years-old',
    ['ma stags']: 'Over 2 years old',
  },
} as { [K in LivestockTypeName]: Record<string, string> }

interface Props {
  livestockType: LivestockTypeName
  livestockClassName: string
}
export function LivestockClassTooltip(props: Props) {
  const { livestockType, livestockClassName } = props
  const tooltip = LIVESTOCK_CLASS_HELP[livestockType][livestockClassName.toLowerCase()]

  if (tooltip) {
    return (
      <Tippy content={tooltip}>
        <span>
          {livestockClassName}
          <TooltipIcon />
        </span>
      </Tippy>
    )
  } else {
    return <>{livestockClassName}</>
  }
}
